import { Component, Input, TemplateRef, inject } from "@angular/core";
import { compact } from "lodash-es";
import { ReportDesignerItemGroupHorizontal } from "src/app/modules/bootstrap/modules/report/report-design-item";
import { ReportFormRendererComponent } from "src/app/modules/bootstrap/modules/report/report-form-renderer/report-form-renderer.component";

@Component({
  selector: "snt-report-form-renderer-group-horizontal",
  templateUrl: "report-form-renderer-group-horizontal.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererGroupHorizontalComponent {
  @Input()
  item!: ReportDesignerItemGroupHorizontal;

  @Input()
  templateOutlet!: TemplateRef<any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  private readonly reportFormRenderer = inject(ReportFormRendererComponent);

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "group-horizontal",
      config: {
        cols: this.item.config.cols,
        items: compact(
          await Promise.all(
            this.reportFormRenderer.renderers
              .toArray()
              .filter(
                (x) =>
                  x.level === this.level + 1 &&
                  x.parentName === this.item.config.name
              )
              .map((x) =>
                !!x.renderPdfObject
                  ? x.renderPdfObject()
                  : Promise.resolve(null)
              )
          )
        )
      }
    };
  }
}
